export function getSelectionSortAnimations(array) {
    const animations = [];
    selectionSort(array, animations);
    return animations;
}

function selectionSort(array, animations) {
    for(let i = 0; i < array.length - 1; i++) {
        let minIdx = i;
        // this is the position we are sorting, push it to change color
        animations.push(['position', i, false]);
        for(let j = i + 1; j < array.length; j++) {
            // this is the value we are scaning, push it to change color
            animations.push(['scan', j, 'on']);
            // push it again to revert its color
            animations.push(['scan', j, 'off']);
            if(array[j] < array[minIdx]) {
                // this is the previous min value, push to revert the color
                if(minIdx !== i) animations.push(['min', minIdx, false]);
                minIdx = j;
                // this is the min value, push it change color
                animations.push(['min', j, true]);
            }
        }
        if(minIdx !== i) {
            const temp = array[i];
            array[i] = array[minIdx];
            array[minIdx] = temp;
            // revert the color at minIdx
            animations.push(['min', minIdx, false]);
            // change their height after swap
            animations.push(['swap', i, array[i]]);
            animations.push(['swap', minIdx, array[minIdx]]);
        }
        // the position is in final sorted order, push it to change color
        animations.push(['position', i, true]);
    }
    // last position is automatically in sorted order, push it to change color
    animations.push(['position', array.length - 1, true]);
}
